import { HButton } from "@highway/hwy-design-system";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import ThumbUpRoundedIcon from "@mui/icons-material/ThumbUpRounded";
import { Stack } from "@mui/material";
import { useSearchParams } from "next/navigation";
import { useState } from "react";

const FeedbackButton = () => {
    const searchParams = useSearchParams();
    const [clicked, setClicked] = useState(false);
    const articleID = searchParams.get("articleID");
    const loID = searchParams.get("loId");
    const text = clicked ? "Thanks for your feedback" : "This info is helpful";

    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            <HButton
                aria-label={`${articleID}-${loID}`}
                className="section-button"
                variant="text"
                onClick={() => setClicked(true)}
                size="small"
                disabled={clicked}
                style={{ textDecoration: "none" }}
            >
                {text}
            </HButton>
            {clicked ? (
                <CheckRoundedIcon style={{ width: "16px", height: "16px" }} />
            ) : (
                <ThumbUpRoundedIcon
                    sx={{ width: "16px", height: "16px", color: (theme) => theme.palette.primaryPurple.main }}
                />
            )}
        </Stack>
    );
};

export default FeedbackButton;
